import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { makeSapConnectionUseCases } from '@/main/factories/use-cases/sap-connection-use-cases.js';
import { SapConnectionController } from '@/presentation/controllers/sap-connection-controller.js';

export const makeSapConnectionController = (httpClient: FetchHttpClient): SapConnectionController => {
    const useCases = makeSapConnectionUseCases(httpClient);
    return new SapConnectionController(useCases.get, useCases.upsert, useCases.test);
};
